export const parseBrowser = (userAgent: string) => {
  if (/edg/i.test(userAgent)) return "Edge";
  if (/opr\//i.test(userAgent) || /opera/i.test(userAgent)) return "Opera";
  if (/samsungbrowser/i.test(userAgent)) return "Samsung Internet";
  if (/ucbrowser/i.test(userAgent)) return "UC Browser";
  if (/brave/i.test(userAgent)) return "Brave";
  if (/vivaldi/i.test(userAgent)) return "Vivaldi";
  if (/yabrowser/i.test(userAgent)) return "Yandex";
  if (/coc_coc_browser/i.test(userAgent)) return "Cốc Cốc";
  if (/chrome/i.test(userAgent)) return "Chrome";
  if (/firefox/i.test(userAgent)) return "Firefox";
  if (/safari/i.test(userAgent)) return "Safari";
  if (/msie|trident/i.test(userAgent)) return "Internet Explorer";
  if (/bot|crawl|spider/i.test(userAgent)) return "Bot";
  return "Unknown";
};
export const parseOS = (userAgent: string) => {
  if (/windows nt 10/i.test(userAgent)) return "Windows 10/11";
  if (/windows nt 6.3/i.test(userAgent)) return "Windows 8.1";
  if (/windows nt 6.2/i.test(userAgent)) return "Windows 8";
  if (/windows nt 6.1/i.test(userAgent)) return "Windows 7";
  if (/windows/i.test(userAgent)) return "Windows";
  if (/iphone/i.test(userAgent)) return "iOS (iPhone)";
  if (/ipad/i.test(userAgent)) return "iOS (iPad)";
  if (/ipod/i.test(userAgent)) return "iOS (iPod)";
  if (/macintosh|mac os x/i.test(userAgent)) return "macOS";
  if (/android/i.test(userAgent)) return "Android";
  if (/ubuntu/i.test(userAgent)) return "Ubuntu";
  if (/debian/i.test(userAgent)) return "Debian";
  if (/fedora/i.test(userAgent)) return "Fedora";
  if (/linux/i.test(userAgent)) return "Linux";
  if (/cros/i.test(userAgent)) return "Chrome OS";
  if (/blackberry/i.test(userAgent)) return "BlackBerry";
  if (/windows phone/i.test(userAgent)) return "Windows Phone";
  return "Unknown";
};
export const parseDevice = (userAgent: string) => {
  if (/bot|crawl|spider/i.test(userAgent)) return "Bot";
  if (/ipad|tablet|(android(?!.*mobile))/i.test(userAgent)) {
    return "Tablet";
  }
  if (/mobi|iphone|ipod|android.*mobile|windows phone/i.test(userAgent)) {
    return "Mobile";
  }
  return "Desktop";
};
